// extracted by mini-css-extract-plugin
export default {"text-arrow-row":"Courses_text-arrow-row__9U5bx","text-col":"Courses_text-col__awoqu","arrow":"Courses_arrow__7WTF8","course-button":"Courses_course-button__nxDNx"};